var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{class:[
  _vm.$style.styledSwitch,
  ( _obj = {}, _obj[_vm.$style.isDisabled] = _vm.disabled, _obj )
]},[_c('b-switch',{attrs:{"value":_vm.value,"type":_vm.type,"disabled":_vm.disabled},on:{"input":_vm.emitInput}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }